import React from "react";
import Avatar from "material-ui/Avatar";
import { darkBlack } from "material-ui/styles/colors";
import { Draggable } from 'react-beautiful-dnd';

const calculateQuantity = (showQuantity, ol) =>
  showQuantity === true && ol.quantity > 1
    ? <span key="quantity" style={{ color: "red" }}>
        {` ${ol.quantity} x `}
      </span>
    : "";

const calculateName = ol =>
  "" + ol.variation.product.name + " (" + ol.variation.name + ")";

const calculateCustomer = getTeamById => (name, team) =>
  name
    ? <div key="customer" 
    // style={{ float: "right" }}
    >
        <span style={{color: 'blue'}}>{`⇨ ${name}(${team ? getTeamById(team) : ""})`}</span>
      </div>
    : "";

const calculateDescription = getTeamById => variationDetails => {
  const description = variationDetails
    .map(f => {
      const value = f.name === 'Equipo' ? getTeamById(f.value) : f.value;
      const desc = `${f.name}: ${value}`;
      return desc;
    })
    // .reduce((a, b) => a + " - " + b);
    .reduce((a, b) => (<div>{a} <br /> {b}</div>));
  return description;
};

const OrderLineListItem = ({
  index,
  // orderId,
  orderLine,
  // onClick,
  // rightIcon,
  // showPrice,
  showQuantity,
  customerName,
  customerTeam,
  getTeamById,
  // moreOptions
}) => {
  let avatarImage;
  try {
    avatarImage = require("../../images/" + orderLine.variation.image);
  } catch (ex) {
    avatarImage = require("../../images/noimage.png");
  }


  const getStatusColor = status => 
  status === "DOING"
  ? "orange"
  : orderLine.status === "DONE" ? "lightgreen" : "lightgrey"


  const cardStyle = {
    margin: 2,
    padding: 2,
    border: '1px solid #aaa',
    backgroundColor: 'white',
    borderLeft: `6px solid ${getStatusColor(orderLine.status)}`,
  }

  return (
    <Draggable
    draggableId={`${orderLine.orderId}|${orderLine.id}`}
    index={index}
  >
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <div style={{...cardStyle}}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <Avatar size={30} src={avatarImage} />
            {/* <div style={listItemStyle} /> */}
            <div style={{marginLeft: 6}}>
              {[
                calculateQuantity(showQuantity, orderLine),
                calculateName(orderLine)
              ]}
            </div>
          </div>
          <div style={{fontSize: 'small'}}>
            {
              <div>
                <span style={{ color: darkBlack }}>
                  {calculateDescription(getTeamById)(orderLine.variationDetails)}
                </span>
                {calculateCustomer(getTeamById)(customerName, customerTeam)}
              </div>
            }
          </div>
        </div>
      </div>
    )}

  </Draggable>
  );
};

export default OrderLineListItem;



// WEBPACK FOOTER //
// ./src/components/presentational/OrderLineListItem2.js